import { render } from "./TheK01Header.vue?vue&type=template&id=4b017d6f&scoped=true&ts=true"
import script from "./TheK01Header.vue?vue&type=script&lang=ts"
export * from "./TheK01Header.vue?vue&type=script&lang=ts"

import "./TheK01Header.vue?vue&type=style&index=0&id=4b017d6f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b017d6f"]])

export default __exports__